import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fadeOp } from 'src/app/util/animations.util';

@Component({
  selector: 'app-email-verfication',
  templateUrl: './email-verfication.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    '../../../check-email/components/check-email/check-email.component.css',
    './email-verfication.component.css'
  ],
  animations: [
    fadeOp
  ]
})
export class EmailVerficationComponent implements OnInit {
  isVerified: boolean = false;
  isSuccess: boolean = false;
  constructor(
    private user: UserService,
    private route: ActivatedRoute,
    private utility: UtilityService
  ) { }

  ngOnInit(): void {
    this.verifiToken()
  }
  verifiToken(): void {
    this.isVerified = false;
    this.route.params.subscribe(params => {
      const token = params.token;
      this.user.verifyEmail(token)
      .then(() => {
        this.isVerified = true;
        this.isSuccess = true;
      })
      .catch(() => {
        this.isVerified = true;
        this.isSuccess = false;
      })
        // this.isVerified = true;
        // this.isSuccess = response.status == 1;
    });
  }
  changeLang(lang: string): void {
    this.utility.changeLang(lang)
  }
  get availableLangs(): string[] {
    return this.utility.getAvailableLang()
  }
  get currentLang(): string {
    return this.utility.getLang();
  }
}
